export const SHARED_CARD_STYLES = {
  className: 'h-full rounded-lg border border-[#CDCDCD] min-h-[215px]',
  headStyle: {
    padding: '0 16px',
    backgroundColor: '#F8F8F8',
  },
  bodyStyle: {
    paddingRight: '16px',
    paddingLeft: '16px',
    height: 'calc(100% - 56px)',
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
};
